import { useState } from "react";

import {
  addClickRecord,
  formatCalendarDate,
  formatTimestampDate,
  getCaseId,
  getClientId,
} from "../../../../Utils/helper";
import incident from "../../../../../public/bp_assets/img/incident.svg";
import useClientPage from "../contact-panel/hooks/useClientPage";
import "./Relationship.css";
import DefaultThumbnail from "../../../common/defaultPhotoSlot";
import { PhotoSlot } from "../../../../Modules/NewCasePage";
import NewCaseExistingClientModalClientPage from "../../modals/new-case-existing-client-modal";
import addIconGold from "../../../../assets/Add-icon-gold.svg";

// import useClientRelationship from "./hooks/useClientRelationship";

const RelationshipTab = ({ client_cases, refetch }) => {
  const [showAddNewCaseExisitingClient, setShowNewCaseExistingClientModal] = useState(false);
  // eslint-disable-next-line unused-imports/no-unused-vars
  // const { , refetch } = useClientRelationship();
  const { clientData, refetch: refetchClient } = useClientPage(getClientId(), getCaseId());
  const defaultThumbnailProps = {
    height: "349px",
    width: "255px",
    borderColor: "var(--primary-15)",
  };
  return (
    <>
      <div
        className="d-flex m-b-5"
        style={{
          gap: "5px",
        }}
      >
        {" "}
        <div className="flex flex-column">
          {clientData?.processed_photo_slots
            ? clientData.processed_photo_slots.map((photoSlot, index) => {
                if (!photoSlot?.photo) {
                  return (
                    <DefaultThumbnail
                      key={`empty-${index}`}
                      {...defaultThumbnailProps}
                      photoData={photoSlot}
                      photoSlots={clientData?.processed_photo_slots}
                      pageName="Client"
                      refetch={refetchClient}
                    />
                  );
                }
                return (
                  <PhotoSlot
                    key={photoSlot.photo?.photo_slot.slot_number}
                    photoSlot={photoSlot?.photo}
                    photoSlots={clientData?.processed_photo_slots}
                    pageName="Client"
                    slotNumber={photoSlot.photo?.photo_slot.slot_number}
                    height="349"
                    width="255"
                    refetch={refetchClient}
                  />
                );
              })
            : Array.from({ length: 1 }).map((_, index) => (
                <DefaultThumbnail
                  key={`skeleton-${index}`}
                  {...defaultThumbnailProps}
                  photoData={null}
                />
              ))}
        </div>
        <div
          style={{
            width: "100%",
          }}
        >
          <div className="menu-bar-style w-100">
            <div
              className="client-contact-title text-center w-100 d-flex align-items-center justify-content-center"
              style={{ height: "25px" }}
            >
              Case History
            </div>
          </div>
          <div
            className="table-responsive table--no-card border-0 has-alternate-grey insurance-col-table panel-notes-section-height"
            style={{
              height: "299px",
              overflowY: "scroll",
              scrollbarWidth: "none",
            }}
          >
            <table className="table table-borderless table-striped table-earning">
              <tbody className="tbody-panels">
                {client_cases?.length > 0 &&
                  client_cases.map((cases, index) => (
                    <tr className="" key={`case-${cases?.id || index}`}>
                      <td
                        className="height-21 text-start d-flex align-items-center"
                        id="clientHistoryCaseIconPadding"
                      >
                        <span className="ic ic-19 m-r-5">
                          <img src={cases?.case_type?.icon} alt="" />
                        </span>
                        <span
                          className="white-space-nowrap"
                          style={{
                            fontSize: "14px",
                            color: "black",
                            fontWeight: "600",
                          }}
                        >
                          {cases?.case_type?.name}
                        </span>
                      </td>
                      <td className="height-21 text-start" id="clientHistoryCaseIconPadding">
                        {cases.incident_date ? (
                          <span className="height-21 d-flex align-items-center">
                            <img src={incident} alt="primary" className="ic-19 m-r-5" />
                            <span className="font-weight-semibold">
                              {formatCalendarDate(cases?.incident_date)}
                            </span>
                          </span>
                        ) : null}
                      </td>
                      <td className="height-21 text-center" id="clientHistoryCaseIconPadding">
                        {cases?.auto_case_stage &&
                          cases?.auto_case_stage?.length > 0 &&
                          cases?.auto_case_stage?.map((stages, stageIndex) => (
                            <span
                              key={`stage-${stageIndex}`}
                              className="font-weight-semibold p-r-5"
                            >
                              {stages}
                            </span>
                          ))}
                      </td>
                      <td className="height-21 text-end" id="clientHistoryCaseIconPadding">
                        {cases.open === "True" ? (
                          <>
                            <span className="color-green fw-bold m-r-5">OPEN:</span>
                            <span className="font-weight-semibold">
                              {formatTimestampDate(cases?.date_open)}
                            </span>
                          </>
                        ) : (
                          <>
                            <span className="colorgrey-2 fw-bold m-r-5">CLOSED</span>
                            <span className="font-weight-semibold">
                              {formatCalendarDate(cases?.date_closed)}
                            </span>
                          </>
                        )}
                      </td>
                    </tr>
                  ))}

                {[...Array(9 - client_cases?.length)].map((_, index) => (
                  <tr key={`additional-${index}`} className="fake-row-2" style={{ height: "21px" }}>
                    <td
                      colSpan="4"
                      id="padding-new-case-history"
                      style={{
                        height: "21px",
                      }}
                    >
                      &nbsp;
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <button
            onClick={() => {
              addClickRecord(999, 2);
              setShowNewCaseExistingClientModal(!showAddNewCaseExisitingClient);
            }}
            style={{
              backgroundColor: "var(--primary-10)",
              color: "var(--primary)",
              border: "1px solid var(--primary)",
            }}
            className="btn info-panel-button-hover-state w-100 font-weight-semibold text-lg height-25 rounded-0 d-flex align-items-center justify-content-center mt-0"
          >
            <span className="fw-bold p-r-5 ic-15 d-flex align-items-center">
              <img className="d-flex align-items-center justify-content-center" src={addIconGold} />
            </span>
            New Case For Client
          </button>
        </div>
      </div>

      {showAddNewCaseExisitingClient && (
        <>
          <NewCaseExistingClientModalClientPage
            handleClose={() => {
              addClickRecord(999, 2);
              setShowNewCaseExistingClientModal(false);
            }}
            show={showAddNewCaseExisitingClient}
            refetch={refetch}
          />
        </>
      )}
    </>
  );
};

export default RelationshipTab;
